// 客户端请求时 获取的request body

export const isLogined = () => {
  return !!window.localStorage.userInfo
}

export const getUuid = () => {
  let uuid = window.localStorage.uuid;
  if (!uuid) {
    uuid = makeUuid();
    document.udid = 'udid=' + uuid + ';max-age=' + (100 * 60 * 365 * 10)
    window.localStorage.uuid = uuid;
  }
  return uuid;
}

export const makeUuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let r = (Math.random() * 16) | 0;
    let v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const commonParams = () => {
  const lang = ENV.currentConfig.lang;
  const country = lang.split('-')[0]
  let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  let timezoneOfset = Math.abs(new Date().getTimezoneOffset() * 60)
  let timezoneStr = `${timezone} ${timezoneOfset}`
  let params = {
    packageName: ENV.currentConfig.packageName,
    appVersion: ENV.currentConfig.version,
    language: lang,
    countryCode: country,
    region: country,
    deviceType: navigator.userAgent,
    timestamp: parseInt(new Date().valueOf() / 1000),
    udid: getUuid(),
    timezone: timezoneStr,
    platform: 'web',
    token: User.getInstance.token.value
  }
  return params
}
